import React, { useEffect, useMemo, useState } from 'react'
import classNames from 'classnames'
import { VideoBlockProps } from './types'
import { getIframeSrc } from './utils'

export const VideoBlock: React.FC<VideoBlockProps> = ({
  aspectRatio = 16 / 9,
  className,
  contentfulName, // exclude it from ...rest
  contentType, // exclude it from ...rest
  iframeClassName,
  id,
  service = 'youtube',
  title,
  params,
  allow,
  style,
  ...rest
}) => {
  const [origin, setOrigin] = useState('')
  const paddingBottom = Number.isNaN(aspectRatio) ? `${(9 / 16) * 100}%` : `${100 / aspectRatio}%`
  const iframeSrc = useMemo(() => getIframeSrc(id, { ...params, origin }, service), [id, params, origin, service])

  useEffect(() => setOrigin(window.location.origin), [])

  return (
    <div
      className={classNames('relative', className, { 'aspect-w-16 aspect-h-9': !aspectRatio })}
      style={{ paddingBottom, ...style }}
    >
      <iframe
        {...rest}
        allow={allow}
        className={classNames(iframeClassName, { 'absolute h-full w-full top-0 bottom-0 right-0 left-0': aspectRatio })}
        title={title}
        src={iframeSrc}
      />
    </div>
  )
}
